<div class="stripe-payment-methods">
  <div class="stripe-payment-methods-header">
    <h4 class="stripe-payment-methods-title" *ngIf="showHeader">Payment methods</h4>
    <!-- Only one card on file is allowed — hide "Add card" once one already exists. -->
    <app-stripe-add-card-button *ngIf="!isLoading && cards.length === 0" label="Add card" (cardSaved)="onCardAdded($event)"></app-stripe-add-card-button>
  </div>

  <div class="stripe-payment-methods-loading" *ngIf="isLoading">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Loading saved cards…</span>
  </div>

  <div class="stripe-payment-methods-error" *ngIf="loadError && !isLoading">{{ loadError }}</div>

  <div class="stripe-payment-methods-empty" *ngIf="!isLoading && !loadError && cards.length === 0">
    No cards on file yet.
  </div>

  <div class="stripe-payment-methods-list" *ngIf="!isLoading && !loadError && cards.length > 0">
    <div class="stripe-payment-methods-row" *ngFor="let card of cards">
      <div class="stripe-payment-methods-row-info">
        <i class="pi pi-credit-card stripe-payment-methods-row-icon"></i>
        <div>
          <div class="stripe-payment-methods-row-title">
            {{ brandLabel(card.cardBrand) }} ending in {{ card.cardLast4 }}
            <span class="stripe-payment-methods-default-badge" *ngIf="card.isDefault">Default</span>
          </div>
          <div class="stripe-payment-methods-row-sub" *ngIf="expiryLabel(card)">Expires {{ expiryLabel(card) }}</div>
        </div>
      </div>
      <div class="stripe-payment-methods-row-actions">
        <button
          pButton
          type="button"
          class="p-button-text stripe-payment-methods-action-btn"
          label="Set default"
          *ngIf="!card.isDefault"
          [disabled]="!!pendingActionId"
          [loading]="pendingActionId === card.paymentMethodId"
          (click)="setDefault(card)"
        ></button>
        <!-- TODO re-enable: hidden now that only one card on file is allowed at all — Remove would
             leave the account with no payment method, which the free-plan/trial-lockout flows don't
             expect. Flip this back on if removing (not just replacing) a card becomes supported. -->
        <button
          pButton
          type="button"
          class="p-button-text p-button-danger stripe-payment-methods-action-btn"
          label="Remove"
          *ngIf="false"
          [disabled]="!!pendingActionId"
          [loading]="pendingActionId === card.paymentMethodId"
          (click)="confirmRemove(card)"
        ></button>
      </div>
    </div>
  </div>
</div>
